// RevoltSwitch - reusable toggle with configurable radius
import './RevoltSwitch.css';

export function RevoltSwitch({
  checked = false,
  onChange,
  label,
  disabled = false,
  radius = 'full', // 'full' or numeric value for px radius
  className = '',
  id,
}) {
  const radiusValue = radius === 'full' ? '999px' : `${radius}px`;
  const thumbRadius = radius === 'full' ? '50%' : `${radius}px`;

  const handleChange = (event) => {
    if (disabled) return;
    onChange?.(event.target.checked);
  };

  const classes = [
    'revolt-switch',
    disabled ? 'is-disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <label className={classes} htmlFor={id}>
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={handleChange}
        disabled={disabled}
      />
      <span
        className="revolt-switch-track"
        style={{ borderRadius: radiusValue }}
      >
        <span
          className="revolt-switch-thumb"
          style={{ borderRadius: thumbRadius }}
        />
      </span>
      {label && <span className="revolt-switch-label">{label}</span>}
    </label>
  );
}

